<template>
  <TableLayout>
    <!-- dialog -->
    <PublicDialog :dialogData="dialogData">
      <template #customization>
        <Customization
          v-if="isCustomization"
          ref="customization"
          :rowData="rowData"
          :colsData='colsData'
        />
      </template>
    </PublicDialog>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <div class="tableBox">
        <div class="printBox">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
            label-position="top"
          >
            <el-form-item label="物料编码" prop="wlbm">
              <!-- <el-input
                maxlength="60"
                v-model="ruleForm.wlbm"
                v-trim
                placeholder="请输入物料编码"
              ></el-input> -->
              <el-autocomplete
                class="inline-input"
                v-model="ruleForm.wlbm"
                :fetch-suggestions="querySearch"
                placeholder="请输入物料编码"
                :trigger-on-focus="true"
                @select="handleSelect"
                style="width: 100%"
                :popper-append-to-body="false"
                :key="searchKey"
                highlight-first-item
              >
                <template slot-scope="{ item }">
                  <p class="historyOption" v-if="item.id !== 'button'">
                    <span v-if="item.display" class="delOption">{{
                      `${item.wlbm}------${item.wlms}------${item.dddw}`
                    }}</span>
                    <span v-if="!item.display">{{
                      `${item.wlbm}------${item.wlms}------${item.dddw}`
                    }}</span>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      circle
                      v-if="item.display"
                      @click.stop="deleteHistory(item)"
                    ></el-button>
                  </p>
                  <p style="margin: 0; text-align: center" v-else>
                    <span v-if="searchHistoryData.length == 1"
                      >无搜索历史记录</span
                    >
                    <el-button
                      type="plain"
                      @click.stop="clearHistory"
                      v-else
                      style="width: 100%"
                      >清空历史记录</el-button
                    >
                  </p>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="批次号" prop="pc">
              <el-autocomplete
                class="inline-input"
                v-model="ruleForm.pc"
                :fetch-suggestions="querySearch_PC"
                placeholder="请输入批次号"
                :trigger-on-focus="true"
                @select="handleSelect_PC"
                style="width: 100%"
                :popper-append-to-body="false"
                :key="searchKey_PC"
                highlight-first-item
              >
                <template slot-scope="{ item }">
                  <p class="historyOption" v-if="item.id !== 'button'">
                    <span class="delOption">{{ item.text }}</span>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      circle
                      @click.stop="deleteHistory_PC(item)"
                    ></el-button>
                  </p>
                  <p style="margin: 0; text-align: center" v-else>
                    <span v-if="searchHistoryData_PC.length == 1"
                      >无打印历史记录</span
                    >
                    <el-button
                      type="plain"
                      @click.stop="clearHistory_PC"
                      v-else
                      style="width: 100%"
                      >清空历史记录</el-button
                    >
                  </p>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="物料描述" prop="wlms">
              <el-input
                maxlength="110"
                v-model="ruleForm.wlms"
                type="textarea"
                :rows="2"
                :autosize="{ minRows: 2, maxRows: 4 }"
                v-trim
                placeholder="请输入物料描述"
              ></el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="计量单位" prop="dddw">
                  <el-input
                    maxlength="60"
                    v-model="ruleForm.dddw"
                    v-trim
                    placeholder="请输入计量单位"
                  ></el-input>
                  <!-- <el-select
                v-model="ruleForm.dddw"
                placeholder="请选择计量单位"
              >
                <el-option v-for="item in optionArr" :label="item.label" :value="item.vlaue" :key="item.id"></el-option>
              </el-select> -->
                </el-form-item>
              </el-col>
              <div v-if="!['lygFour','lygFive'].includes(templateKey)">
                <el-col :span="8">
                  <el-form-item label="供应商" prop="gysmc">
                    <el-input
                      maxlength="110"
                      v-model="ruleForm.gysmc"
                      v-trim
                      placeholder="请输入供应商"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div v-if="['lygFour','lygFive'].includes(templateKey)">
                <el-col :span="8">
                  <el-form-item label="需求部门" prop="demandDepartment">
                    <el-input
                      maxlength="110"
                      v-model="ruleForm.demandDepartment"
                      v-trim
                      placeholder="请输入需求部门"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="项目名称" prop="entryName">
                    <el-input
                      maxlength="110"
                      v-model="ruleForm.entryName"
                      v-trim
                      placeholder="请输入项目名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div v-if="['tp','jxl','dl','lygTwo','lyg-gn-2','lyg-dh-2'].includes(templateKey)">
                <el-col :span="8">
                  <el-form-item label="日期" prop="date">
                    <el-date-picker
                      style="width: 100%"
                      v-model="ruleForm.date"
                      value-format="yyyy-MM-dd"
                      align="right"
                      type="date"
                      placeholder="请选择日期"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </div>
              <div v-if="['lygThree'].includes(templateKey)">
                <el-col :span="8">
                  <el-form-item label="入库日期" prop="createTime">
                    <el-date-picker
                      style="width: 100%"
                      v-model="ruleForm.createTime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      align="right"
                      type="datetime"
                      placeholder="请选择入库日期"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="标签数量" prop="copies">
                  <el-input-number
                    v-model="ruleForm.copies"
                    :min="1"
                    :max="20"
                    style="width: 100%"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <div v-if="['lyg','lygSix','lygSeven','lygEight','lygNine','lyg-gn-1','lyg-gn-szl-2'].includes(templateKey) || !templateKey">
                <el-col :span="8">
                  <el-form-item label="库位" prop="storageLocationProject">
                    <el-input
                      maxlength="110"
                      v-model="ruleForm.storageLocationProject"
                      v-trim
                      placeholder="请输入库位"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div v-if="['lygThree','lygFour','lygFive'].includes(templateKey)">
                <el-col :span="8">
                  <el-form-item label="工厂编码" prop="gc">
                    <el-input
                      maxlength="4"
                      show-word-limit
                      v-model="ruleForm.gc"
                      v-trim
                      placeholder="请输入工厂编码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div v-if="['tp'].includes(templateKey)">
                <el-col :span="8">
                  <el-form-item label="托盘号" prop="stock">
                    <el-input
                      maxlength="110"
                      v-model="ruleForm.stock"
                      v-trim
                      placeholder="请输入托盘号"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div v-if="['dl'].includes(templateKey)">
                <el-col :span="8">
                  <el-form-item label="仓位号" prop="shippingSpace">
                    <el-input
                      maxlength="110"
                      v-model="ruleForm.shippingSpace"
                      v-trim
                      placeholder="请输入仓位号"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出厂编码" prop="factoryCode">
                    <el-input
                      maxlength="110"
                      v-model="ruleForm.factoryCode"
                      v-trim
                      placeholder="请输入出厂编码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <!-- lyg -->
            <div v-if="['lyg','lygSix','lygSeven','lygEight','lygNine','lyg-gn-1','lyg-gn-szl-2'].includes(templateKey) || !templateKey">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="物资数量" prop="materialsNum">
                    <el-input-number
                      v-model="ruleForm.materialsNum"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- lygThree -->
            <div v-if="['lygThree','lygFour','lygFive'].includes(templateKey)">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="实物数量" prop="htsl">
                    <el-input-number
                      v-model="ruleForm.htsl"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- lygTwo,lyg-gn-2,lyg-dh-2 -->
            <div v-if="['lygTwo','lyg-gn-2','lyg-dh-2'].includes(templateKey)">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="入库数量" prop="numberDisks">
                    <el-input-number
                      v-model="ruleForm.numberDisks"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出库数量" prop="quantityIssued">
                    <el-input-number
                      v-model="ruleForm.quantityIssued"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="库存数量" prop="balanceQuantity">
                    <el-input-number
                      v-model="ruleForm.balanceQuantity"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- tp -->
            <div v-if="['tp'].includes(templateKey)">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="组盘数量" prop="numberDisks">
                    <el-input-number
                      v-model="ruleForm.numberDisks"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发出数量" prop="quantityIssued">
                    <el-input-number
                      v-model="ruleForm.quantityIssued"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="结存数量" prop="balanceQuantity">
                    <el-input-number
                      v-model="ruleForm.balanceQuantity"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- jxl -->
            <div v-if="['jxl'].includes(templateKey)">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="入库数量" prop="numberDisks">
                    <el-input-number
                      v-model="ruleForm.numberDisks"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出库数量" prop="quantityIssued">
                    <el-input-number
                      v-model="ruleForm.quantityIssued"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="库存数量" prop="balanceQuantity">
                    <el-input-number
                      v-model="ruleForm.balanceQuantity"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- dl -->
            <div v-if="['dl'].includes(templateKey)">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="组盘长度" prop="numberDisks">
                    <el-input-number
                      v-model="ruleForm.numberDisks"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发出数量" prop="quantityIssued">
                    <el-input-number
                      v-model="ruleForm.quantityIssued"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="结存长度" prop="balanceQuantity">
                    <el-input-number
                      v-model="ruleForm.balanceQuantity"
                      :min="0"
                      :precision="3"
                      :step="1"
                      style="width: 100%"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-form-item label="备注" prop="remarks">
              <el-input
                maxlength="110"
                v-model="ruleForm.remarks"
                type="textarea"
                :rows="2"
                :autosize="{ minRows: 2, maxRows: 4 }"
                v-trim
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
            <div class="printBtn">
              <el-button type="primary" @click="submitFormFirst('ruleForm')" size="medium">
                定制化
              </el-button>
              <el-button v-if="print_manufacturers.includes('DeTong')" type="primary" @click="submitForm('ruleForm')" size="medium">
                打印
              </el-button>
              <el-button v-if="print_manufacturers.includes('JiaBo')" type="primary" @click="submitFormJiaBo('ruleForm')" size="medium">
                佳博打印
              </el-button>
              <el-button @click="resetForm('ruleForm')" size="medium">重置</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </template>
  </TableLayout>
</template>

<script>
import Pagination from "@/components/common/Pagination";
import TableLayout from "@/layouts/TableLayout";
import BaseTable from "@/components/base/BaseTable";
import SearchFormCollapse from "@/components/common/SearchFormCollapse";
import {
  longRangeSearchApi,
  searchHistoryApi,
  addHistoryApi,
  delHistoryApi,
  clearHistoryApi,
  searchHistoryApi_PC,
  addHistoryApi_PC,
  delHistoryApi_PC,
  clearHistoryApi_PC,
  getListFiledApi
} from "@/api/manual_label_printing";
var imgUrl = require("../../../assets/images/logo_gjdw.png");
// import {
//   returnPrintTemplate,
//   printFn,
// } from "@/views/custom_data_management/printTemplate";
// import {importExcelApi,exportExcelApi,exportExcelTemApi} from '@/api/WeeklyScheduleData'
// import {blobAndExcelDownload} from '@/views/publicCom/publicImport'
import Customization from "./customization";
import { mapState } from "vuex";
export default {
  name: "manual_label_printing",
  extends: BaseTable,
  components: { SearchFormCollapse, TableLayout, Pagination, Customization },
  data() {
    var gcRuleFn = (rule, value, callback) => {
      if (value!==value.replace(/[^a-zA-Z0-9]/g, '')) {
        callback(new Error('请输入数字和英文组合')); 
      }else{
        callback();
      }
    };
    this.rules = {
      copies: [
        {
          required: true,
          message: "请输入标签数量",
          trigger: ["blur", "change"],
        },
      ],
      // wlbm: [
      //   {
      //     required: true,
      //     message: "请输入物料编码",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // pc: [
      //   {
      //     required: true,
      //     message: "请输入批次号",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // wlms: [
      //   {
      //     required: true,
      //     message: "请输入物料描述",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // dddw: [
      //   {
      //     required: true,
      //     message: "请输入计量单位",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // gysmc: [
      //   {
      //     required: true,
      //     message: "请输入供应商",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // numberDisks: [
      //   {
      //     required: true,
      //     message: "请输入数量",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // quantityIssued: [
      //   {
      //     required: true,
      //     message: "请输入数量",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // balanceQuantity: [
      //   {
      //     required: true,
      //     message: "请输入数量",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // date: [
      //   { required: true, message: "请选择日期", trigger: ["blur", "change"] },
      // ],
      // createTime: [
      //   { required: true, message: "请选择入库日期", trigger: ["blur", "change"] },
      // ],
      // storageLocationProject: [
      //   {
      //     required: true,
      //     message: "请输入库位",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      gc: [
        {
          required: true,
          message: "请输入工厂编码",
          trigger: ["blur", "change"],
        },
        { validator: gcRuleFn, trigger: ["blur", "change"], }
      ],
      // stock: [
      //   {
      //     required: true,
      //     message: "请输入托盘号",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // shippingSpace: [
      //   {
      //     required: true,
      //     message: "请输入仓位号",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // factoryCode: [
      //   {
      //     required: true,
      //     message: "请输入出厂编码",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // materialsNum: [
      //   {
      //     required: true,
      //     message: "请输入物资数量",
      //     trigger: ["blur", "change"],
      //   },
      // ],
      // htsl: [
      //   {
      //     required: true,
      //     message: "请输入实物数量",
      //     trigger: ["blur", "change"],
      //   },
      // ],
    };
    return {
      colsData:[],
      pickerOptions: {
        // disabledDate(time) {
        //   return new Date().getFullYear() < time.getFullYear()||new Date().getFullYear() > time.getFullYear();
        //   // return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      templateKey: null,
      searchKey_PC: "",
      searchHistoryData_PC: [],
      searchKey: "",
      optionArr: [],
      ruleForm: {
        copies: "",
        wlbm: "",
        pc: "",
        wlms: "",
        dddw: "",
        gysmc: "",
        demandDepartment:"",
        entryName:"",
        remarks: "",
        gc:"",
        stock: "",
        storageLocationProject:"",
        date: "",
        createTime:"",
        numberDisks: "",
        materialsNum:"",
        htsl:"",
        quantityIssued: "",
        balanceQuantity: "",
        shippingSpace: "",
        factoryCode: "",
      },
      rowData: {},
      isCustomization: false,
      // dialog数据源
      dialogData: [
        {
          data: [], // 传递数据slot
          name: "customization", // dialog插槽名
          key: "customization", // 区分唯一性key
          isDialog: false, // 是否显示dialog
          isBtn: true, // 是否显示cancel和confirm按钮
          title: "定制化", // header提示内容
          width: "80%", // dialog宽度
          // lockScroll: true,
          // closeModal: false,
          // closePressEscape: false,
          // showClose: false,
          cancelBtnName: "取消",
          confirmBtnName: "打印",
          colseFn: this.closeFnCustomization,
          // handleClickCancel: this.handleClickCustomizationCancel, // dialog取消
          handleClickConfirm: this.handleClickCustomizationConfirm, // dialog确定,
          isCustom:true,
          isConfirmBtnHide:false,
          handleClickCustom:this.handleClickCustomJiaBo,
          customBtnName:'佳博打印'
        },
      ],
      searchData: [],
      searchHistoryData: [],
    };
  },
  async mounted() {
    await this.historySearch();
    await this.historySearch_PC();
    longRangeSearchApi().then((res) => {
      this.searchData =
        res &&
        res.map((item) => ({
          ...item,
          value: `${item.wlbm}------${item.wlms}------${item.dddw}`,
        }));
    });
  },
  computed: {
    ...mapState(["templateObj","print_manufacturers"]),
  },
  watch: {
    templateObj: {
      handler(newVal) {
        this.templateKey = newVal?.templateKey;
        this.resetForm("ruleForm");
        getListFiledApi({
          templateKey: newVal?.templateKey,
          key: "1",
        }).then(res=>{
          this.colsData=res||[];
        })
      },
      immediate: true,
    },
    print_manufacturers: {
      handler(newVal) {
        this.dialogData[0].isConfirmBtnHide=!(newVal.includes('DeTong'));
        this.dialogData[0].isCustom=newVal.includes('JiaBo');
      },
      immediate:true
    },
  },
  methods: {
    submitFormJiaBo(formName) {
      console.log({ ...this.ruleForm });
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addHistoryApi_PC({ text: this.ruleForm.pc }).then((res) => {
            this.historySearch_PC();
          });
          let arr = [];
          for (let i = 0; i < this.ruleForm.copies; i++) {
            arr.push({ ...this.ruleForm, imgUrl });
          }
          sessionStorage.setItem('printArr',JSON.stringify(arr))
          sessionStorage.setItem('printerParams',JSON.stringify({
            templateId:this.templateObj?.id,
            templateType:"20",
            dataType:"99",
            matPrintVoList:[this.ruleForm]
          }))
          let routeData = this.$router.resolve({
              name: "printTem",
              query: {},
          });
          window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");

          setTimeout(() => {
            this.resetForm("ruleForm");
          }, 300);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteHistory_PC(row) {
      delHistoryApi_PC(row).then((res) => {
        this.historySearch_PC();
      });
    },
    historySearch_PC() {
      searchHistoryApi_PC().then((res) => {
        this.searchHistoryData_PC =
          res && res.map((item) => ({ ...item, value: item.text }));
        this.searchHistoryData_PC.push({ id: "button" });
        this.searchKey_PC = new Date().getTime();
      });
    },
    clearHistory_PC() {
      clearHistoryApi_PC({}).then((res) => {
        this.historySearch_PC();
      });
    },
    querySearch_PC(queryString, cb) {
      var searchData = this.searchHistoryData_PC;
      var results = queryString
        ? searchData.filter(this.createFilter_PC(queryString))
        : searchData;
      // 调用 callback 返回建议列表的数据
      if (queryString && results.length === 1) return cb([]);
      cb(results);
    },
    createFilter_PC(queryString) {
      return (restaurant) => {
        if (restaurant.id === "button") return true;
        return (
          restaurant.value?.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect_PC(item) {
      if (item.id === "button") return;
      this.ruleForm.pc = item.text;
    },
    //物料编码
    deleteHistory(row) {
      delHistoryApi(row).then((res) => {
        this.historySearch();
      });
    },
    historySearch() {
      searchHistoryApi().then((res) => {
        this.searchHistoryData =
          res &&
          res.map((item) => ({
            ...item,
            value: `${item.wlbm}------${item.wlms}------${item.dddw}`,
          }));
        this.searchHistoryData.push({ id: "button" });
        this.searchKey = new Date().getTime();
      });
    },
    clearHistory() {
      clearHistoryApi().then((res) => {
        this.historySearch();
      });
    },
    querySearch(queryString, cb) {
      if (queryString) {
        var searchData = this.searchData;
        var results = queryString
          ? searchData.filter(this.createFilter(queryString))
          : searchData;
        // 调用 callback 返回建议列表的数据
        cb(results);
      } else {
        var searchData = this.searchHistoryData;
        var results = queryString
          ? searchData.filter(this.createFilter(queryString))
          : searchData;
        // 调用 callback 返回建议列表的数据
        cb(results);
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect(item) {
      if (item.id === "button") return;
      this.ruleForm.wlms = item.wlms;
      this.ruleForm.dddw = item.dddw;
      this.ruleForm.wlbm = item.wlbm.split("------")[0] || null;
      addHistoryApi(this.ruleForm).then((res) => {
        this.historySearch();
      });
    },
    closeFnCustomization() {
      this.isCustomization = false;
    },
    handleClickCustomJiaBo(item, index) {
      let customizationConfirmData = this.$refs.customization.apiData;
      let arr = [];
      customizationConfirmData &&
        customizationConfirmData.forEach((item) => {
          arr.push({
            ...item,
          });
        });

      setTimeout(() => {
        sessionStorage.setItem('printArr',JSON.stringify(arr))
        sessionStorage.setItem('printerParams',JSON.stringify({
            templateId:this.templateObj?.id,
            templateType:"20",
            dataType:"99",
            matPrintVoList:customizationConfirmData
          }))
        let routeData = this.$router.resolve({
            name: "printTem",
            query: {},
        });
        window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");
      }, 300);

      this.dialogData[index].isDialog = false;
      this.resetForm("ruleForm");
    },
    handleClickCustomizationConfirm(item, index) {
      let customizationConfirmData = this.$refs.customization.apiData;
      let arr = [];
      customizationConfirmData &&
        customizationConfirmData.forEach((item) => {
          arr.push({
            ...item,
          });
        });

      setTimeout(() => {
        sessionStorage.setItem("printArr", JSON.stringify(arr));
        sessionStorage.setItem('printerParams',JSON.stringify({
            templateId:this.templateObj?.id,
            templateType:"10",
            dataType:"99",
            matPrintVoList:customizationConfirmData
          }))
        let routeData = this.$router.resolve({
          name: "print",
          query: {},
        });
        window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");
      }, 300);

      this.dialogData[index].isDialog = false;
      this.resetForm("ruleForm");
    },
    submitFormFirst(formName) {
      this.$refs[formName].validate(async (valid, obj) => {

        let arr = Object.keys(obj);
        if (valid || (arr.length == 1 && arr[0] == "storageLocation")) {
          addHistoryApi_PC({ text: this.ruleForm.pc }).then((res) => {
            this.historySearch_PC();
          });

          this.rowData = { ...this.ruleForm };
          this.isCustomization = true;
          this.dialogData[0].isDialog = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm(formName) {
      console.log({ ...this.ruleForm });
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addHistoryApi_PC({ text: this.ruleForm.pc }).then((res) => {
            this.historySearch_PC();
          });
          let arr = [];
          for (let i = 0; i < this.ruleForm.copies; i++) {
            arr.push({ ...this.ruleForm, imgUrl });
          }
          sessionStorage.setItem("printArr", JSON.stringify(arr));
          sessionStorage.setItem('printerParams',JSON.stringify({
            templateId:this.templateObj?.id,
            templateType:"10",
            dataType:"99",
            matPrintVoList:[this.ruleForm]
          }))
          let routeData = this.$router.resolve({
            name: "print",
            query: {},
          });
          window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");

          setTimeout(() => {
            this.resetForm("ruleForm");
          }, 300);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName] && this.$refs[formName].resetFields();
    },
  },
  created() {
    // this.ruleForm.date=new Date().getFullYear() +  "-" +(new Date().getMonth() + 1).toString().padStart(2, "0") +  "-" + new Date().getDate().toString().padStart(2, "0");
    // this.config({
    //   module: "手动打印标签",
    //   api: "/manual_label_printing",
    //   "field.main": "templateTitle",
    //   sorts: [
    //     {
    //       property: "CREATE_TIME",
    //       direction: "DESC",
    //     },
    //   ],
    // });
    // this.search();
  },
};
</script>
<style>
/* .addEdit .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
} */
/* .ReadSendObject .el-dialog {
  left: 50%;
  top: 17%;
  transform: translate(-50%, -17%);
  margin: 0px !important;
} */
/* 美化滚动条 */
body {
  margin: 0;
  overflow: overlay;
}
::-webkit-scrollbar {
  background-color: transparent;
  width: 12px;
}
::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 8px;
  background-clip: content-box;
  border: 2px solid transparent;
}
body[scroll]::-webkit-scrollbar-thumb,
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
<style scoped lang="scss">
@import "@/assets/style/variables.scss";

.box {
  position: absolute;
  left: 10px;
  bottom: 20px;
}
.printBox {
  width: 700px;
  padding: 10px 40px;
  border-radius: 10px;
  // border: 5px outset gray;
  margin-bottom: 16px;
  background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
  // height: 700px;
  // // padding:0 10px;
  // overflow-y: auto;
  // overflow-x: hidden;
}
.tableBox {
  display: flex;
  align-items: center;
  justify-content: center;
}
.printBtn {
  display: flex;
  justify-content: center;
  align-items: center;
}
// /deep/ .el-form-item.is-success .el-input__inner{
//   border-color: #61D6F1;
// }
/deep/ .el-autocomplete-suggestion__wrap {
  max-height: 300px;
}
/deep/ .el-autocomplete-suggestion {
  left: 0 !important;
}
.historyOption {
  display: flex;
  justify-content: space-between;
  margin: 0;
  .delOption {
    width: 90%;
    overflow: hidden;
  }
  .el-button {
    width: 10%;
  }
  span {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.printBox /deep/ .el-input .el-input__inner {
  font-size: 16px;
}

.printBox /deep/ .el-textarea__inner {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 16px;
}
/* 修改验证器样式 */
// /deep/ .el-form-item.is-error .el-input__inner {
// 		border-color: #889aa4;
// }
// /deep/ .el-form-item.is-error .el-input__validateIcon {
// 		color: #889aa4;
// }
.printBox /deep/ .el-form-item__error {
  // color: #e6a23c;
  font-size: 14px;
}
.printBox /deep/ .el-form-item__label {
  font-size: 16px;
}
</style>
